import { Box, IconButton, Modal } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";

import { Button, Paragraph, StyledGrid, Link } from "components/simple";
import { color, fontFamily, fontSize, spacingDefaults } from "style/constants";
import { useDispatch } from "hooks";
import { ApolloQueryResult } from "@apollo/client";
import { GetAppropriateAssessmentCycleOverviewData } from "../types";

interface SubmitForReviewModalProps {
  show: boolean;
  userAssessmentCycleId: string;
  notesCount: number;
  refetch(): Promise<ApolloQueryResult<GetAppropriateAssessmentCycleOverviewData>>;
  onAccept: () => void;
  onCancel: () => void;
}
const SubmitForReviewModal: React.FC<SubmitForReviewModalProps> = ({
  show,
  userAssessmentCycleId,
  notesCount,
  refetch,
  onAccept,
  onCancel
}: SubmitForReviewModalProps) => {
  const dispatch = useDispatch();

  return (
    <Modal onClose={onCancel} open={show}>
      <StyledGrid
        alignItems="center"
        backgroundColor={color.WHITE}
        border={`1px solid ${color.MUTEDGRAY}`}
        borderRadius="8px"
        container
        direction="column"
        left="50%"
        padding={`${spacingDefaults.xlarge} ${spacingDefaults.large}`}
        position="absolute"
        textAlign="center"
        top="50%"
        transform="translateX(-50%) translateY(-50%)"
        width="600px"
      >
        <StyledGrid
          item
          position="absolute"
          right={spacingDefaults.xsmall}
          top={spacingDefaults.xsmall}
        >
          <IconButton aria-label="close" key="close" onClick={onCancel}>
            <Close />
          </IconButton>
        </StyledGrid>
        <StyledGrid item marginBottom={spacingDefaults.normal}>
          <Paragraph
            color={color.BLACK}
            fontFamily={fontFamily.secondary}
            fontSize={fontSize.header}
            lineHeight={fontSize.xlarge}
          >
            Are you sure you want to Submit for Review?
          </Paragraph>
        </StyledGrid>
        <StyledGrid item marginBottom={spacingDefaults.normal}>
          <Paragraph color={color.DARKGRAY}>
            The status will be updated to Ready for Review to indicate that you are requesting
            feedback. Please leave a note with any comments you have for reviewers.
          </Paragraph>
        </StyledGrid>
        <StyledGrid item marginBottom="2rem" width="250px">
          <Box marginBottom=".5rem">
            <Button
              inverted
              fullWidth
              onClick={() => {
                dispatch({
                  type: "open_notes_modal",
                  userAssessmentCycleId: userAssessmentCycleId,
                  refetch
                });
              }}
            >
              Add Note
            </Button>
          </Box>
          <Box>
            <Link to={`/internal-notes/${userAssessmentCycleId}`}>View {notesCount} note(s)</Link>
          </Box>
        </StyledGrid>
        <StyledGrid item width="250px">
          <Button onClick={onAccept} fullWidth>
            Submit for Review
          </Button>
        </StyledGrid>
        <StyledGrid item marginTop="1rem">
          <Button inverted onClick={onCancel}>
            Cancel
          </Button>
        </StyledGrid>
      </StyledGrid>
    </Modal>
  );
};

export default SubmitForReviewModal;
